<template>
  <el-dialog
    :append-to-body="true"
    title="变更记录"
    :visible.sync="dialogForm.visible"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    width="40%"
    v-dialogDrag
    @open="openDialog"
  >
    <el-table border :data="tableData" height="300px">
      <el-table-column label="序号" type="index" width="55"></el-table-column>
      <el-table-column label="属性名称" prop="attrName" show-overflow-tooltip> </el-table-column>
      <el-table-column label="变更前" prop="beforeValue" show-overflow-tooltip> </el-table-column>
      <el-table-column label="变更后" prop="afterValue" show-overflow-tooltip> </el-table-column>
      <el-table-column label="变更时间" prop="changTime" show-overflow-tooltip> </el-table-column>
      <el-table-column label="变更人" prop="changUserName" show-overflow-tooltip> </el-table-column>
      <el-table-column label="版本号" prop="changId"> </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import ChangeLogService from '@/services/ChangeLogService'

export default {
  props: ['dialogForm'],
  data() {
    return {
      tableData: [],
    }
  },
  methods: {
    async getTableData() {
      const res = await ChangeLogService.getChangeListByClassFirst({
        classId: this.dialogForm.classId,
        dataId: this.dialogForm.dataId,
      })
      if (res && res.code === 0) {
        this.tableData = res.data
      }
    },
    openDialog() {
      this.getTableData()
    },
  },
}
</script>
